import { render, staticRenderFns } from "./MedicalDevicesModels.vue?vue&type=template&id=a17aeff4"
import script from "./MedicalDevicesModels.vue?vue&type=script&lang=js"
export * from "./MedicalDevicesModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports